/**
 * to represent either document is uploaded or folder is uploaded
 */
export enum UploadType {
    File = "file",
    Folder = "Folder",
}